import { render, staticRenderFns } from "./EditCalendar.vue?vue&type=template&id=f633ab80&scoped=true"
import script from "./EditCalendar.vue?vue&type=script&lang=ts"
export * from "./EditCalendar.vue?vue&type=script&lang=ts"
import style0 from "./EditCalendar.vue?vue&type=style&index=0&id=f633ab80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f633ab80",
  null
  
)

export default component.exports